import { createContext, createElement, type ReactNode, useContext } from 'react';

type NativeRouteChrome = {
  hasNativeHeader: boolean;
  hasNativeTabBar: boolean;
};

const defaultNativeRouteChrome: NativeRouteChrome = {
  hasNativeHeader: false,
  hasNativeTabBar: false,
};

const NativeRouteChromeContext = createContext<NativeRouteChrome>(defaultNativeRouteChrome);

export function NativeRouteChromeProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: NativeRouteChrome;
}) {
  return createElement(NativeRouteChromeContext.Provider, { value }, children);
}

export function useNativeRouteChrome() {
  return useContext(NativeRouteChromeContext);
}
